module.exports = __webpack_public_path__ + "static/media/logo.4e32960c.svg";